import React from 'react';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import queryString from 'query-string';
import axios from 'axios';
import toast from 'react-hot-toast';

import Inlineloader from '../../../../components/Loader/InlineLoader';
import { getSafalEventCheckIn, updateUserSafalEventCheckIn } from '../../../../services/Service';
import QrReader from './QrReader';

const CheckInPage = () => {
  const { id } = useParams();
  const { user } = useSelector((state) => state.login);

  const [inviteInfo, setInviteInfo] = React.useState(null);
  const [allPeople, setAllPeople] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [scannedResult, setScannedResult] = React.useState('');
  const [qrOn, setQrOn] = React.useState(true);
  const navigate = useNavigate();

  const getInviteInfo = async () => {
    setLoading(true);
    try {
      const res = await getSafalEventCheckIn(id);
      setInviteInfo(res.data.data);
      const _people = [];
      res.data.data?.invites?.forEach((invite) => {
        invite?.people?.forEach((person) => {
          _people.push({ ...person, inviteId: invite?._id });
        });
      });
      setAllPeople(_people);
      // const findYou = res.data.data?.people?.find((e) => e.email === paramEmail);
      // if (findYou) findYou?.status === 'Accepted' && setIsYouSubmitted(true);
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getInviteInfo();
  }, []);

  const allReadyCheckedIn = allPeople?.find(
    (e) => e?.account === user?._id && e?.status === 'Accepted' && e?.checkIn === 'Done'
  );
  const isYouInvited = allPeople?.find((e) => e?.account === user?._id && e?.status === 'Accepted');

  const onCheckIn = async () => {
    try {
      const findInvite = allPeople?.find((e) => e?.account === user?._id);

      const payload = {
        inviteId: findInvite?.inviteId, // required
        email: findInvite?.email,
        checkIn: 'Done', // Done, Pending
      };
      const res = await updateUserSafalEventCheckIn(payload);
      if (res.status === 200) {
        toast.success('Checked In Successfully');
        navigate('/');
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  const scannedResultFind = scannedResult?.includes(`safalevent-invite-check-in/${id}`);

  if (loading) return <Inlineloader />;

  //   if (!inviteInfo) return <Navigate to={'/dashboard'} />;

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          margin: 'auto',
          marginTop: '100px',
          borderRadius: '12px',
          maxWidth: '400px',
          backgroundColor: 'white',
          alignItems: 'center',
          padding: '20px',
        }}
      >
        <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#3D71FF' }}>Event Check-In</span>
        <span>{inviteInfo?.name}</span>
        <QrReader scannedResult={scannedResult} setScannedResult={setScannedResult} qrOn={qrOn} setQrOn={setQrOn} />
        {allReadyCheckedIn ? (
          <>
            <span>You have already checked in</span>
          </>
        ) : (
          scannedResultFind && <Button onClick={onCheckIn}>Check In</Button>
        )}
      </div>
    </div>
  );
};

export default CheckInPage;
